module.exports = __webpack_public_path__ + "0359a00faee59a1f80cddcb27ea7a2b8.jpg";